import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiGet } from "../../../utils/apiRequests";
import {
  GET_SELECTED_LEAGUE_LOADING,
  GET_SELECTED_LEAGUE_ERROR,
  GET_SELECTED_LEAGUE_SUCCESS,
} from "../../../constant/actionTypes";

export const getSelectedLeague = (leagueId) => (dispatch) => {
  dispatch({ type: GET_SELECTED_LEAGUE_LOADING });

  apiGet(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.selectedLeague}/${leagueId}`,
    (response) => {
      if (response.error == true) {
        dispatch({
          type: GET_SELECTED_LEAGUE_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: GET_SELECTED_LEAGUE_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: GET_SELECTED_LEAGUE_ERROR, response: error });
    }
  );
};
